module.exports = __webpack_public_path__ + "static/teleco_18-2fc3465655b4843742fb9e9a5c536fd5.jpg";